import React from 'react';
// eslint-disable-next-line
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from '../pages/Home';
import Eula from '../pages/Eula';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import Support from '../pages/Support';
import Uninstall from '../pages/Uninstall';
import Welcome from '../pages/Welcome';
import Byebye from '../pages/Byebye';
import Firefox from '../pages/Firefox';
import ErrorNotFound from '../pages/ErrorNotFound';

const Routes = () => (
  <div>
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/eula" component={Eula} />
      <Route path="/privacy-policy" component={PrivacyPolicy} />
      <Route path="/support" component={Support} />
      <Route path="/uninstall" component={Uninstall} />
      <Route path="/welcome2" component={Welcome} />
      <Route path="/byebye" component={Byebye} />
      <Route path="/firefox" component={Firefox} />
      <Route path="*" component={ErrorNotFound} />
    </Switch>
  </div>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes.js